import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import _ from 'lodash'
import { FormattedMessage, useIntl } from 'react-intl';

import 'draft-js/dist/Draft.css';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import FormHelperText from '@mui/material/FormHelperText';
import Tooltip from '@mui/material/Tooltip';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';

import useGlobalStatus from '../../hook/useGlobalStatus';
import useColorSystem from '../../hook/useColorSystem';

import {
  HelpOutlineIcon,
  CheckBoxOutlineBlankIcon,
  CheckBoxIcon,
  HighlightOffOutlinedIcon,
  KeyboardArrowDownOutlinedIcon,
  CorporateFareIcon,
} from '../../constants/images';

import theme from '../../theme';

import { CustomFormLabel } from '../customComponent';


const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;


const NameAndAccountData = (props) => {
  const {
    media,
    cidList,
    selectedAdAccounts,
    setSelectedAdAccounts,
    reportName,
    setReportName,
    handleInput,
    inputErrorMsg,
  } = props;

  const intl = useIntl();
  const { currentActiveData, setCurrentActiveData, locale, setLocale, entryPath, setEntryPath } = useGlobalStatus();
  const { colorMedia, mainColor, lightColor, darkColor, w01Color } = useColorSystem();

  useEffect(() => {
    if (entryPath.includes('edit')) {
      setReportName(currentActiveData.weeklyReportName);
    }
  }, [entryPath, currentActiveData])

  return (
    <Box>
      <Typography
        sx={{
          ...theme.typography.h4_normal,
          mb: 2,
          color: theme.palette.grey.w700,
        }}
      >
        <CorporateFareIcon sx={{ mr: 0.5, verticalAlign: 'sub' }} />
        <FormattedMessage id="createData.header.AccountAndName" />
      </Typography>

      <Box mb={2}>
        <CustomFormLabel>
          <FormattedMessage id="createData.reportName.reportName" /><span>*</span>
          <Tooltip title={<FormattedMessage id="createData.reportName.tip" />} placement="bottom-start">
            <HelpOutlineIcon variant="dark" />
          </Tooltip>
        </CustomFormLabel>

        <TextField
          name="reportName"
          placeholder={intl.formatMessage({ id: "createData.reportName.placeholder" })}
          color={colorMedia}
          value={reportName}
          onChange={handleInput}
          error={inputErrorMsg.reportName || false}
          sx={{ width: '100%' }}
        />
        <FormHelperText error sx={{ fontSize: 14 }}>
          {inputErrorMsg?.reportName &&
            <FormattedMessage id={inputErrorMsg.reportName} />
          }
        </FormHelperText>
      </Box>

      <Box mb={2}>
        <CustomFormLabel>
          <FormattedMessage id="createData.account.account" values={{ media }} /><span>*</span>
          <Tooltip title={<FormattedMessage id="createData.account.tip" />} placement="bottom-start">
            <HelpOutlineIcon variant="dark" />
          </Tooltip>
        </CustomFormLabel>

        <Autocomplete
          multiple
          size="small"
          id="selectCID"
          options={cidList}
          disableCloseOnSelect={cidList.length > 1 ? true : false}
          disableClearable={true}
          noOptionsText={<FormattedMessage id="createData.account.noOptionsText" />}
          value={selectedAdAccounts}
          getOptionLabel={(option) => `${option.adAccountId} ${option.adAccountName}`}
          renderOption={(props, option, { selected }) => (
            <li {...props}>
              <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                color={colorMedia}
                checked={selected}
                style={{ marginRight: 8 }}
              />
              {`${option.adAccountId} ${option.adAccountName}`}
            </li>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              color={colorMedia}
              placeholder={intl.formatMessage({ id: "createData.account.placeholder" })}
            />
          )}
          onChange={(event, newValue) => { setSelectedAdAccounts(newValue) }}
          ChipProps={{ deleteIcon: <HighlightOffOutlinedIcon /> }}
          popupIcon={<KeyboardArrowDownOutlinedIcon />}
        />

        <FormHelperText error sx={{ fontSize: 14 }}>
          {inputErrorMsg?.fbAdAccounts &&
            <FormattedMessage id={inputErrorMsg.fbAdAccounts} />
          }
        </FormHelperText>

      </Box>
    </Box>
  )
}

export default NameAndAccountData;